import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const downloadFW_ListingPDF = ({ reportData }) => {
  const doc = new jsPDF("landscape", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const now = new Date();
  const timestamp = now.toLocaleString();

  // ======================
  // HEADER
  // ======================
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Fee Waiver Listing Report", pageWidth / 2, 15, {
    align: "center",
  });

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Generated: ${timestamp}`, pageWidth / 2, 21, {
    align: "center",
  });

  doc.line(14, 25, pageWidth - 14, 25);

  // ======================
  // FLATTEN DATA FOR PDF
  // ======================
  const body = [];

  reportData.forEach((group) => {
    // GROUP HEADER ROW (merged style row)
    body.push([
      {
        content: `Fee Waiver: ${group.fw_desc} | Yearly: ${group.yrly_perm} | Monthly: ${group.mthly_install} | Status: ${group.fw_status}`,
        colSpan: 8,
        styles: {
          fillColor: [217, 237, 247],
          fontStyle: "bold",
          textColor: [0, 0, 0],
        },
      },
    ]);

    body.push([
      {
        content: `Category: ${group.fw_catg} | Budget: ${group.bgt_name} | Sub Budget: ${group.sub_bgt_name}`,
        colSpan: 8,
        styles: {
          fillColor: [217, 237, 247],
          fontStyle: "bold",
        },
      },
    ]);

    // SUB HEADER
    body.push([
      "Fee Components",
      "Waiver %",
      "Inst-1",
      "Inst-2",
      "Inst-3",
      "Inst-4",
      "Inst-5",
      "Inst-6",
    ]);

    // DETAILS
    group.details.forEach((d) => {
      body.push([
        d.fee_desc,
        d.fw_perc,
        d.fw_inst1,
        d.fw_inst2,
        d.fw_inst3,
        d.fw_inst4,
        d.fw_inst5,
        d.fw_inst6,
      ]);
    });

    // spacing row
    body.push([
      {
        content: "",
        colSpan: 8,
        styles: { minCellHeight: 5 },
      },
    ]);
  });

  // ======================
  // TABLE
  // ======================
  autoTable(doc, {
    startY: 30,
    head: [],
    body,

    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: "linebreak",
    },

    columnStyles: {
      0: { cellWidth: 60 },
      1: { halign: "right" },
      2: { halign: "right" },
      3: { halign: "right" },
      4: { halign: "right" },
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
    },

    didParseCell: (data) => {
      // style sub-header row
      if (
        data.cell.raw === "Fee Components" ||
        data.cell.raw === "Waiver %" ||
        data.cell.raw === "Inst-1" ||
        data.cell.raw === "Inst-2" ||
        data.cell.raw === "Inst-3" ||
        data.cell.raw === "Inst-4" ||
        data.cell.raw === "Inst-5" ||
        data.cell.raw === "Inst-6" 
      ) {
        data.cell.styles.fillColor = [230, 230, 230];
        data.cell.styles.fontStyle = "bold";
      }
    },

    didDrawPage: () => {
      doc.setFontSize(8);
      doc.setTextColor(120);

      doc.text(
        `Page ${doc.getNumberOfPages()}`,
        pageWidth - 14,
        pageHeight - 10,
        { align: "right" }
      );
    },
  });

  doc.save("Fee_Waiver_Listing.pdf");
};
